<button
  *appHasPermission="[Permission.APPOINTMENT_WAITING_LIST_VIEW]"
  mat-icon-button
  [matTooltip]="statusText$ | async | translate"
  matTooltipPosition="above"
  [matMenuTriggerFor]="waitListMenu"
  (click)="$event.stopPropagation()"
>
  <mat-progress-spinner
    *ngIf="process?.inProgress"
    diameter="24"
    mode="indeterminate"
  ></mat-progress-spinner>
  <mat-icon *ngIf="!process?.inProgress" [ngClass]="statusColor$ | async">
    schedule
  </mat-icon>
</button>

<mat-menu #waitListMenu="matMenu">
  <button *appHasPermission="'message.create'" mat-menu-item [matMenuTriggerFor]="reachOutMenu">
    <mat-icon>send</mat-icon>
    {{ 'wait-list.menu.reach-out.label' | translate }}
  </button>
  <a *ngIf="requestLink$ | async as requestLink" mat-menu-item [routerLink]="requestLink">
    <mat-icon>book_online</mat-icon>
    {{ 'wait-list.menu.view-request' | translate }}
  </a>
  <ng-container
    *appHasPermission="
      ['appointment.edit', 'appointment.waiting-list.delete'];
      operator: 'AND'
    "
  >
    <button
      *ngIf="!appointment.waitList"
      mat-menu-item
      (click)="onOpenWaitlistDialog()"
    >
      <mat-icon>today</mat-icon>
      {{ 'wait-list.menu.add-waitlist' | translate }}
    </button>
    <ng-container *ngIf="appointment.waitList">
      <button mat-menu-item (click)="onOpenWaitlistDialog()">
        <mat-icon>today</mat-icon>
        {{ 'wait-list.menu.update-waitlist' | translate }}
      </button>
      <button mat-menu-item (click)="removeWaitList()">
        <mat-icon color="warn">close</mat-icon>
        {{ 'wait-list.menu.remove-waitlist' | translate }}
      </button>
    </ng-container>
  </ng-container>
</mat-menu>

<mat-menu #reachOutMenu="matMenu">
  <button
    mat-menu-item
    mmxConfirmClick
    [message]="'wait-list.menu.reach-out.sms-confirm' | translate"
    (confirm)="onNotifyPatient({ method: 'sms', appointment })"
    [disabled]="!patient?.canText"
  >
    {{ 'common.send-via.text' | translate }}
  </button>
  <button
    mat-menu-item
    mmxConfirmClick
    [message]="'wait-list.menu.reach-out.email-confirm' | translate"
    (confirm)="onNotifyPatient({ method: 'email', appointment })"
    [disabled]="!patient?.canEmail"
  >
    {{ 'common.send-via.email' | translate }}
  </button>
</mat-menu>
